class ComponentBackgroundImage extends Theme.Component {
  connectedCallback() {
    this.observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      this.observer.disconnect();

      this.render();

      this.addDirectEvent("resize", window, Theme.Helpers.debounce(this.render.bind(this), 150));
    }, { rootMargin: "200px" });

    this.observer.observe(this.parentElement);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.observer) {
      this.observer.disconnect();
    }
  }

  get isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  render() {
    const source = this.isMobile && this.dataset.srcMobile ? this.dataset.srcMobile : this.dataset.src;
    const position = this.isMobile && this.dataset.positionMobile ? this.dataset.positionMobile : this.dataset.position;

    if (!source || source === this.applied) {
      return;
    }

    this.applied = source;

    const element = this.parentElement;

    element.style.backgroundImage = `url("${this.optimize(source)}")`;
    element.style.backgroundSize = "cover";
    element.style.backgroundRepeat = "no-repeat";
    element.style.backgroundPosition = position;
  }

  optimize(source) {
    const url = new URL(source, location.origin);
    const resolution = window.devicePixelRatio || 1;
    const width = this.parentElement.clientWidth || window.innerWidth;

    url.searchParams.set("width", Math.round(width * resolution));

    return url.toString();
  }
}

customElements.define("component-background-image", ComponentBackgroundImage);
